import * as types from '../types/brands'
import company from 'api/company'

const brandsApi = company.brands

export const updateExistingBrandAct = (brand) => ({ type: types.UPDATE_EXISTING_BRAND, brand })
export const setAllBrandsAct = (brands) => ({ type: types.SET_ALL_BRANDS, brands })
export const addNewBrandAct = (brand) => ({ type: types.ADD_NEW_BRAND, brand })
export const deleteBrandAct = (brand) => ({ type: types.DELETE_BRAND, brand })

export function getBrands(params) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      brandsApi.getBrands(params).then(({ data, status }) => {
        if (status === 200) {
          dispatch(setAllBrandsAct(data.results))
          return resolve(data)
        }
        return reject(data)
      })
    })
  }
}

export function addNewBrand(brand, Companyid) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      brandsApi.addBrand(brand).then(({ data, status }) => {
        if (status === 200) {
          dispatch(addNewBrandAct(data.results))
          return resolve(data)
        }
        return reject(data)
      })
    })
  }
}

export function updateBrand(brand) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      brandsApi.updateBrand(brand).then(({ data, status }) => {
        if (status === 200) {
          dispatch(updateExistingBrandAct(brand))
          return resolve(data)
        }
        return reject(data)
      })
    })
  }
}

export function deleteBrand(brand) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      brandsApi.deleteBrand(brand).then(({ data, status }) => {
        if (status === 200) {
          dispatch(deleteBrandAct(brand))
          return resolve(data)
        }
        return reject(data)
      })
    })
  }
}
